var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8225_3659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2717 3.84505C10.2813 2.85669 8.96078 2.3125 7.56068 2.3125C6.16058 2.3125 4.84006 2.85669 3.84672 3.84505C1.80109 5.88649 1.80109 9.21044 3.84672 11.2519C4.83711 12.2402 6.15763 12.7844 7.55773 12.7844C8.95784 12.7844 10.2784 12.2402 11.2687 11.2519C13.3173 9.21044 13.3173 5.88649 11.2717 3.84505ZM10.6468 10.6283C9.82148 11.4519 8.72498 11.9049 7.55773 11.9049C6.39049 11.9049 5.29398 11.4519 4.46866 10.6283C2.7679 8.93099 2.7679 6.16593 4.47161 4.46866C5.29693 3.64502 6.39344 3.19202 7.56068 3.19202C8.72792 3.19202 9.82443 3.64502 10.6498 4.46866C12.3505 6.16888 12.3505 8.93099 10.6468 10.6283ZM13.9923 13.8073L12.3535 12.1718C12.2267 12.0453 11.9437 11.9777 11.7315 12.1718C11.5311 12.3542 11.6048 12.6836 11.7315 12.8131L13.3704 14.4486C13.4352 14.5133 13.7683 14.678 14.0071 14.4309C14.2045 14.2279 14.122 13.9338 13.9923 13.8073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5625,
    cy: 7.56299,
    r: 5.20177,
    stroke: "white",
    strokeWidth: 1.65354
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9375 12.3755L13.6875 14.1255",
    stroke: "white",
    strokeWidth: 1.65354,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8225_3659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlice);
export default __webpack_public_path__ + "static/media/slice.2a8dd099b7032ed04be42a95930a6582.svg";
export { ForwardRef as ReactComponent };